import { makeStyles, tokens } from '@fluentui/react-components';

const GROUP_LISTBOX_MIN_WIDTH = '28rem';
const GROUP_LISTBOX_MAX_HEIGHT = '20rem';
const GROUP_LISTBOX_VIEWPORT_WIDTH = `calc(100vw - ${tokens.spacingHorizontalL} * 2)`;

export const useAcgPickerStyles = makeStyles({
  pickerCard: {
    display: 'flex',
    alignItems: 'stretch',
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke1,
    borderRightColor: tokens.colorNeutralStroke1,
    borderBottomColor: tokens.colorNeutralStroke1,
    borderLeftColor: tokens.colorNeutralStroke1,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    overflow: 'hidden',
  },

  labelSide: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: tokens.colorNeutralStroke1,
    backgroundColor: tokens.colorNeutralBackground2,
    flexShrink: '0',
    minWidth: '120px',
  },

  labelText: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    whiteSpace: 'nowrap',
  },

  inputSide: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    minWidth: '0',
  },

  combobox: {
    width: '100%',
    minWidth: '0',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '&:focus-within': {
      border: 'none',
      boxShadow: 'none',
    },
  },

  listbox: {
    width: 'max-content',
    minWidth: `min(${GROUP_LISTBOX_MIN_WIDTH}, ${GROUP_LISTBOX_VIEWPORT_WIDTH})`,
    maxWidth: GROUP_LISTBOX_VIEWPORT_WIDTH,
    maxHeight: `min(${GROUP_LISTBOX_MAX_HEIGHT}, 50vh)`,
    overflowY: 'auto',
    overflowWrap: 'anywhere',
  },

  groupIdHint: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    fontFamily: tokens.fontFamilyMonospace,
    paddingLeft: tokens.spacingHorizontalXS,
    marginTop: tokens.spacingVerticalXXS,
    minHeight: tokens.lineHeightBase200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  addButton: {
    flexShrink: '0',
    alignSelf: 'center',
    marginRight: tokens.spacingHorizontalS,
  },

  errorText: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorPaletteRedForeground1,
    paddingTop: tokens.spacingVerticalXXS,
  },
});
